import Http from '@/classes/http/Http'
import Transform from '@/classes/form/Transform'

export default {
  getComments (filter) {
    return Http.get({
      url: `comments/review-results${filter}`
    })
  },
  getCommentForm (reviewResultId) {
    return Http.get({
      url: `comments/review-results/${reviewResultId}/form`
    })
  },
  postCommentForm (reviewResultId, formAndFileData) {
    return Http.post({
      url: `comments/review-results/${reviewResultId}/form`,
      data: Transform.createMultipartFormData(formAndFileData)
    })
  },
  patchCommentForm (reviewResultId, formAndFileData) {
    return Http.patch({
      url: `comments/review-results/${reviewResultId}/form`,
      data: Transform.createMultipartFormData(formAndFileData)
    })
  },
  deleteComment (reviewResultId) {
    return Http._delete({
      url: `comments/review-results/${reviewResultId}/form`
    })
  }
}
